import React from "react";
import styles from "./LedgerViewTabBar.module.scss";
import { matterLedgerTabId } from "pages/MatterLedger/matterLedgerTabs";

const LedgerViewTabBar = ({ tabItems, selectedTabId, onSelect }) => (
  <div className={styles.bar}>
    {tabItems.map((tab) => {
      const id = matterLedgerTabId(tab);
      const isActive = id === selectedTabId;
      return (
        <button
          key={id}
          type="button"
          className={`${styles.tab} ${isActive ? styles.active : ""}`}
          onClick={() => onSelect(tab)}
        >
          {tab.label}
        </button>
      );
    })}
  </div>
);

export default LedgerViewTabBar;
